export const MESSAGE_FETCHING_CHART_DATA = 'Fetching chart data';
export const MESSAGE_FETCHING_VISUALIZATION_TEMPLATE = 'Fetching custom panel';
